module.exports = __webpack_public_path__ + "static/media/bride-buffet.9a865593.jpg";